<template>
  <div class="pc-radio-switcher">
    <div class="pc-switch-body" @click="update">
      <div :class="{'active': value}" class="pc-switcher"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PcRadioSwitcher',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update'],
  methods: {
    update() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style scoped>

</style>
